import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';

import AuthFeedbackView from '@/pages/Auth/AuthFeedbackView';

import StripeStatus from './StripeStatus';

export enum STRIPE_STATUS_ROUTES {
    SUCCESS = '/success',
    ERROR = '/error',
}

const StripePaymentResult = () => {
    const { t } = useTranslation();

    return (
        <Routes>
            <Route
                path={STRIPE_STATUS_ROUTES.SUCCESS}
                element={
                    <CenterContainer>
                        <StripeStatus />
                    </CenterContainer>
                }
            />
            <Route
                path={STRIPE_STATUS_ROUTES.ERROR}
                element={
                    <AuthFeedbackView
                        title={t('stripe_status_error_title')}
                        subtitle={t('stripe_status_error_subtitle')}
                        ctaLabel={t('stripe_status_error_cta')}
                        hideMarketplaceButtons
                    />
                }
            />
        </Routes>
    );
};

const CenterContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
`;

export default memo(StripePaymentResult);
